@let sourceValue = source();
@if (sourceValue === 'ch') {
  <div class="map-container-ch">
    <a href="https://www.naturgefahren.ch/" target="_blank">
      <img
        src="https://www.naturgefahren.ch/warnkarte.png"
        width="300"
        style="border: 0"
        alt="Warnkarte Naturgefahrenportal" />
    </a>
  </div>
}

@if (sourceValue === 'dwd') {
  <div class="map-container-de">
    <a href="https://www.dwd.de/warnungen" target="_blank">
      <img
        src="https://www.dwd.de/DWD/warnungen/warnapp_gemeinden/json/warnungen_gemeinde_map_de.png"
        height="320"
        style="border: 0"
        alt="DWD Warnkarte" />
    </a>
  </div>
}

@if (sourceValue === 'fr') {
  <div class="map-container-fr">
    <a href="https://vigilance.meteofrance.fr/fr" target="_blank">
      <img
        src="https://wm-custom-shared.s3.eu-west-1.amazonaws.com/vigilance/QGFR17_LFPW_.gif"
        height="320"
        style="border: 0"
        alt="DWD Warnkarte" />
    </a>
  </div>
}
